export default __webpack_public_path__ + "static/media/book_diligence_c_philosophies.dcff841e.png";